module.exports = __webpack_public_path__ + "static/media/mirageIcon.ed22fc3f.jpg";